import { AppState } from '@modules';

import validateBillingAddress from '@pages/BillingAddress/validateBillingAddress';

export const checkShowBillingAddress = (state: AppState) => {
  return state.user.data && !validateBillingAddress(state.user.data.billing_address);
};
